import Svg, { Path, SvgProps } from 'react-native-svg';

const MoreIcon = (props: SvgProps) => (
  <Svg width={9} height={16} fill="none" {...props}>
    <Path d="m1 15 7-7-7-7" stroke="#000" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export default MoreIcon;
